<template>

    <ion-page id="pitch-coach">
       <ion-content >
         <div :class="{ 'text-dark' : isDark,'text-light' : !isDark }" 
               :style="styleOneFrame">
        <ion-item color="success">
        <h2>Are you a Coach? Or work with a Coach?</h2>
        </ion-item>
        <ion-item>
        Hi,
        <p>I'm adding an exciting new area to the Chessvis program specifically for coaching. It's a 'shared room' where coach and student can interact. Coaches can edit or paste in board positions. Then the student(s) and coach can make moves on the board. And all can chat. Dropped connections won't cause anyone to lose their place in the chat or board position.</p>
        <p>Best of all, it works exactly the same on any device: web browser, Android and IOS. On phones, tablets and desktop.</p>
        <p>If you're a coach, send me an email and I'll set you with an evaluation account. (Please include any links to a coaching website, profile page or just write up what you do.) If you're a student, please tell your coach!</p>
    </ion-item>
    <ion-item>
Henry - henry@chessvis.com
      </ion-item>
      </div>
      </ion-content>
     </ion-page>
    </template>
    
    <script setup>
    
    import { IonItem,IonInput,IonPage, IonContent } from '@ionic/vue';
    
    import { ref, watch } from 'vue'
    import { doStartupCheck } from '@/composables/startupCheck.js'
    import { useConnectionStore } from '@/stores/connectionStore';
    import { useWindowSizeStore } from '@/stores/windowSizeStore';
    
    import { availableWidthHeight } from '@/composables/screenSize'
    const connectionStore = useConnectionStore()
      
    const isDark = ref(connectionStore.getDarkmode != "" && connectionStore.getDarkmode != "light")
    
    const menuTrigger = ref(0)
    
    const styleOneFrame = ref({
       position : "absolute",
       "overflow-y" : "scroll",
       top : "0px",
       left : "100px",
       width: "100px",
       height : "100px"
     })
    
     const source = ref("https://www.chessvis.com/")
    
    const windowSizeStore = useWindowSizeStore()
    const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                          height : windowSizeStore.getWindowSize['height'] })
    updateWidthHeights()
    
    doStartupCheck(false)
    
    watch(() => windowSizeStore.getWindowSize, () => {
        //console.log('*********** window size changes detected')
        windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                          height : windowSizeStore.getWindowSize['height'] }
        //console.log("*** logoff new window size",windowSizeRef.value)
        menuTrigger.value++
        updateWidthHeights()
      })
      
    
    function updateWidthHeights() {
    
      const availableSpace = availableWidthHeight()
      const oneframePositionTop = availableSpace.topIndent
      const oneframePositionLeft = availableSpace.leftRightIndent + availableSpace.leftIndent
      const oneframeHeight = availableSpace.height - oneframePositionTop+ availableSpace.topIndent
      const oneframeWidth = availableSpace.width - availableSpace.leftRightIndent * 2
    
      styleOneFrame.value.height = oneframeHeight + "px"
      styleOneFrame.value.width = oneframeWidth + "px"
      styleOneFrame.value.top = oneframePositionTop + "px"
      styleOneFrame.value.left = oneframePositionLeft + "px"
    }
    
    </script>
    
    <style scoped>
    
    .item{
      margin:10px auto;
    }
    
    </style>